var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/estate/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 430,
      title: '集中管理公司固定资产',
      desc: '轻松维护您所有的业务资产，包括资产，车辆，设备，机械，硬件和其他。在账套中手工创建单个资产，或者使用xml快速批量导入所有资产信息。',
      textWidth: 800,
      imgWidth: 290,
      left: false,
      img: require('@/assets/estate/img1.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 440,
      title: '计算折旧',
      desc: '设置适用于您的业务和资产类型的资产类别。指定购买日期，购买价格，有效期限，残值率，折旧方法，以便准确的计算固定资产的折旧费用和现有价值。',
      textWidth: 670,
      imgWidth: 320,
      left: true,
      img: require('@/assets/estate/img2.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 470,
      title: '全面了解您的固定资产',
      desc: '通过折旧汇总表快速查看指定期间的固定资产折旧情况，包括资产状态，剩余价值，剩余使用期限。',
      textWidth: 700,
      imgWidth: 340,
      left: false,
      img: require('@/assets/estate/img3.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }